var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-login"}},[(_vm.loading)?_c('Loading'):_c('Login',{attrs:{"customItems":_vm.customItemsLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }